export const REF_TYPES = {
  COLLECTION: 'collection',
  DOC: 'doc',
};
